import LieuDetailController from './lieu.detail.controller';

export default {
    template: require('./lieu.detail.html'),
    controller: LieuDetailController
};
